import { render, staticRenderFns } from "./video_list.vue?vue&type=template&id=1ecd4295&scoped=true&"
import script from "./video_list.vue?vue&type=script&lang=js&"
export * from "./video_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecd4295",
  null
  
)

export default component.exports